import type { AgentStreamMessage, PageInitInput, QuestionData, QuestionModule } from '@/domains/seek/types';

export interface PageInitService{
    pageInit(initData: PageInitInput): Promise<QuestionData[]>;
    toSeekAgent(appendData: string, questionId: string): Promise<QuestionData[] | void>;
    stopPageStreamEvent(question_id: string):Promise<unknown>;
    regenerateModules(question: QuestionData, module_names: QuestionModule[]): Promise<QuestionData[]>;
    pageInitWithAgent(message: AgentStreamMessage): void;
}

export const PageInitService = Symbol('PageInitService');
